module.exports = __webpack_public_path__ + "img/semas_SNB.490b4074.svg";